import {Box, Paper} from "@mui/material";
import {Link} from "react-router-dom";
import ProfileSubscriptionRemainedDays from "./ProfileSubscriptionRemainedDays";
import useResponsive from "../../components/hooks/useResponsive";
import {useMainLayoutContext} from "../../context/MainLayoutContext";
import ProfileSubscriptionRemainedDaysSkeleton from "./ProfileSubscriptionRemainedDaysSkeleton";

const ProfileSubscription = () => {

    const {isMd} = useResponsive()
    const {subscriptionData, subscriptionIsLoading} = useMainLayoutContext();

    return (
        <Paper sx={{height: "fit-content"}}>
            <Box sx={{
                display: "flex",
                justifyContent: "center",
                flexWrap: "wrap",
                gap: "30px",
            }}>
                {
                    subscriptionIsLoading || subscriptionData === undefined ? (
                        Array.from({length: 2}).map((_, index) => (
                                <ProfileSubscriptionRemainedDaysSkeleton key={index}/>
                            )
                        )) : (
                        subscriptionData?.map((item) => (
                            <ProfileSubscriptionRemainedDays
                                key={item.id}
                                data={item}
                            />
                        ))
                    )
                }
                <Box sx={{display: "flex", flexDirection: {xs: "column", md: "row"}, gap: "10px", width: "100%"}}>
                    <Link style={{width: isMd ? "60%" : "100%"}} to="/subscription">
                        <button className="btn btn-blue">
                            خرید اشتراک
                        </button>
                    </Link>
                    <Link style={{width: isMd ? "40%" : "100%"}} to="transaction">
                        <button className="btn btn-softblue">
                            تراکنش‌ها
                        </button>
                    </Link>
                </Box>
            </Box>
        </Paper>
    );
};

export default ProfileSubscription;